<template>
  <div>
    <div v-html="language=='zh'?content:contentEn" class="html_div editor-content-view" ></div>
    <!-- <div v-html="contentEn" v-else class="html_div  editor-content-view" ></div> -->
  </div>
</template>
<script>
export default {
  props:{
    id:{
      type:String,
      default:''
    },
    detail:{
      type:String,
      default:''
    },
    detailEn:{
      type:String,
      default:''
    },
    language:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      content: "",
      contentEn: "",
      currentPage:1,
    };
  },
  mounted() {
  },
  methods: {
    getHtml(type){
      console.log('getHtml')
      this.$http
        .get("/hdbs/api/contacts/info/" + type, {
          params: {
            page: this.currentPage,
            limit: 11,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.content = response.data.data.content;
              this.contentEn = response.data.data.contentEn;
            }
          }.bind(this)
        );
    }
  },
};
</script>

<style  lang="stylus" scoped>
.html_div {
  min-height: 50rem;
}
</style>


// WEBPACK FOOTER //
// src/components/CallUs/More.vue